import mutations from "@/_evoli/store/socket/mutations"
import getters from "@/_evoli/store/socket/getters"
import actions from "@/_evoli/store/socket/actions"

import router from "@/_evoli/router/index"
import { refresh } from "@/_evoli/helper/endpoint.js"

export function getSocketDefaultState() {
  return {
    openBy: [],
    userDashboard: [],
    count: {},
    anonStatus: {},
    analyzeProgress: {},
    correctionProgress: {},
    lastListsPayload: ""
  }
}

export default {
  namespaced: true,
  state: getSocketDefaultState(),
  getters,
  mutations,
  actions
}

let reconnectTimeout = null
let subscribed = false

export function socketPlugin() {
  return (store) => {
    if (!subscribed) {
      subscribed = true
      // if(!refreshToken){
      store.subscribe(({ type }) => {
        if (type === "addRefreshToken" && !store.$socket) {
          socketPlugin()(store)
        }
      })
      //   return
      // }
    }

    if (store.$socket && store.$socket.readyState === WebSocket.OPEN) return
    if (!store.getters.getRefreshToken) return

    const socket = new WebSocket(process.env.VUE_APP_SOCKETURL)
    store.$socket = socket

    socket.onopen = () => {
      const route = router.currentRoute
      if (route) {
        store.dispatch("socket/SEND_route", route)
        const lists = route.meta?.lists || []
        if (lists.length > 0) {
          let filter = {}

          if (lists.length === 1) {
            filter = store.state.filterList?.[lists[0].name] || {}
          }

          store.dispatch("socket/SEND_lists", {
            route,
            filter
          })
        }
      }
    }

    socket.onclose = () => {
      const refreshToken = store.getters.getRefreshToken
      store.$socket = null

      store.commit("socket/setLastListsPayload", "")

      if (reconnectTimeout) clearTimeout(reconnectTimeout)
      if (!refreshToken) return

      reconnectTimeout = setTimeout(() => {
        refresh(store).catch(() => {})
      }, 100)
    }

    socket.onmessage = ({ data }) => {
      let parsed
      try {
        parsed = JSON.parse(data)
      } catch (e) {
        // guard against malformed socket payloads to prevent runtime crashes
        console.warn("Invalid socket message:", data)
        return
      }
      store.dispatch("socket/RECIEVE_" + parsed.type, parsed)
    }
  }
}
